import React from 'react'
// @ts-ignore
import Rodal from 'rodal'
// include styles
import 'rodal/lib/rodal.css'
import Input from 'src/components/Fields/Input';

interface ConfirmationModalProps {
  onConfirm?: () => void;
  errors?: any;
  touched?: any;
}

interface ConfirmationModalState {
  visible: boolean;
}

export class ConfirmationModal extends React.Component<ConfirmationModalProps, ConfirmationModalState>{
  constructor(props: ConfirmationModalProps) {
    super(props);
    this.state = { visible: false };
  }

  show = () => {
    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({ visible: false });
  };

  render() {
    return (
      <div>

        <Rodal visible={this.state.visible} className="!w-[50px]" onClose={this.hide}>
          <div className='flex text-center'  style={{ flexDirection: "column"}}>
            <p style={{fontSize: 18, color: '#000'}}>Avez-vous rencontré le gérant physiquement ?</p>
            <div className='flex justify-center text-center mt-5 mb-3'>
              <Input
              label="Oui"
              type="radio"
              name="isPhysicalMeet"
              value='1'
            />
            <Input
              label="Non"
              type="radio"
              name="isPhysicalMeet"
              value='0'
            />
            </div>
            {this.props.touched.isPhysicalMeet && this.props.errors.isPhysicalMeet && (
              <div className="text-red-600 text-sm mt-1">Veuillez indiquer si vous avez rencontré le gérant physiquement.</div>
            )}
            <button
            style={{ width: '260px', position: 'relative' }}
            className="cta my-2 flex-grow-0"
            type="button"
            onClick= {() => {
                this.hide();
                this.props.onConfirm?.();
              }}
            >
              Confirmer
            </button>
          </div>
          
        </Rodal>
      </div>
    );
  }
}
